import { render, staticRenderFns } from "./PagePanel.vue?vue&type=template&id=b83590d6&scoped=true&"
import script from "./PagePanel.vue?vue&type=script&lang=ts&"
export * from "./PagePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83590d6",
  null
  
)

export default component.exports